import React from "react";
import FadeLoader from "react-spinners/FadeLoader";
import AppIcon from "@vcomponents/AppIcon";

import "./style.scss";

import { CustomFormattedMessage } from "@src/utility/context/CustomFormattedMessage";
/**
 * APP PRIMARY BUTTON
 * @param {Object} props
 * @param {String} props.text
 * @param {Element} props.icon
 * @param {Function} props.onClick
 * @param {String} props.className
 * @param {Boolean} props.disabled
 * @param {Boolean} props.isLoading
 * @param {Boolean} props.showLoadingText
 * @param {String} props.loadingText
 * @param {String} props.loaderColor
 *
 * @returns JSX.ELEMENT => button
 */

const AppButton = (props) => {
  const btnClasses = `v2-app-btn ${props.className} ${
    props.disabled ? "disabled" : ""
  } ${props.isLoading ? "isLoading" : ""}`;
  const btnText = props.isLoading
    ? props.showLoadingText
      ? props?.loadingText
      : "Loading..."
    : props.text;

  return (
    <button
      disabled={props?.disabled}
      onClick={props.onClick}
      className={btnClasses}
    >
      {props.icon && !props.isLoading && <AppIcon icon={props.icon} />}
      {props.isLoading && (
        <div className="loader">
          <FadeLoader
            color={props?.loaderColor || "#888888"}
            height={2}
            margin={-14}
            radius={3}
            width={1}
          />
        </div>
      )}
      {props.text && (
        <span className="text">
          <CustomFormattedMessage id={btnText} defaultMessage={btnText} />
        </span>
      )}
    </button>
  );
};

export default AppButton;
